function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 48,
  rx: 8,
  fill: "#E8EAEE"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#1AB0B0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.718 16.293h-6.236a2.21 2.21 0 0 0-2.214 2.203v11.616a2.21 2.21 0 0 0 2.214 2.203h9.257a2.21 2.21 0 0 0 2.213-2.203v-8.09h-5.234s.021-5.73 0-5.73zm1.394 12.404h-6.037a.602.602 0 0 1-.603-.6c0-.332.27-.601.603-.601h6.037c.334 0 .604.269.604.6 0 .332-.27.601-.604.601zm.017-2.384h-6.037a.602.602 0 0 1-.604-.601c0-.332.27-.601.604-.601h6.037c.333 0 .603.27.603.6 0 .332-.27.602-.603.602zM22.36 23.88h-2.27a.602.602 0 0 1-.603-.601c0-.332.27-.601.604-.601h2.27c.333 0 .603.27.603.6 0 .332-.27.602-.604.602z",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.53 16.425v4.803h4.25z"
})));

var SvgUploadedFile = function SvgUploadedFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadedFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uploaded-file.f4376e39.svg";
export { ForwardRef as ReactComponent };